import {useState} from "react";
import {KTSVG} from "../../../../../_metronic/helpers";
import {DeleteGroupForm} from "./DeleteGroupForm";
import {IHandleCloseProps} from "../../models/Modal";

export interface IDeleteGroupProps {
    groupIdList: number[]
    onFinish: () => void
}

/**
 * Удаление групп
 */
export function DeleteGroup({groupIdList = [], onFinish}: IDeleteGroupProps) {
    const [show, setShow] = useState(false)

    const closeModal = ({isSubmitted, ...rest}: IHandleCloseProps) => {
        setShow(false)
        isSubmitted && onFinish()
    }

    return (
        <>
            <div className="px-5 mt-6">
                <div>
                <span className="d-flex align-items-center text-gray-600 fs-6" style={{cursor: "pointer"}} onClick={() => setShow(true)}>
                    <KTSVG path='/media/icons/duotune/general/gen036.svg' className='svg-icon svg-icon-1 me-3 mx-3'/>
                    <span>Удалить группы</span>
                </span>
                </div>
                <DeleteGroupForm groupIdList={groupIdList} show={show} handleClose={closeModal}/>
            </div>
        </>
    )
}
